import React from "react";
import { Sparkles } from "lucide-react";

export const SloganBanner = () => {
  return (
    <div
      data-testid="slogan-banner"
      className="bg-[#2563EB] text-white py-4"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-wrap items-center justify-center gap-3 text-center">
        <Sparkles className="h-5 w-5 text-[#FBBF24]" strokeWidth={2} />
        <p className="font-display text-base sm:text-lg lg:text-xl font-bold tracking-tight">
          “Taylor Made For You” — Honest plumbing, fair pricing, neighbor service.
        </p>
        <Sparkles className="h-5 w-5 text-[#FBBF24]" strokeWidth={2} />
      </div>
    </div>
  );
};

export default SloganBanner;
